var lazy = jQuery('iframe[data-src]').toArray();

e4.util.observer.bind( lazy,function( entry,observer ){
    if( entry.isIntersecting) {
        var jIframe = jQuery(entry.target);
        jIframe.attr('src',jIframe.data('src'));
        observer.unobserve(entry.target);
    }
},e4.settings.ecom.lazyload.observerOptions );